module.exports = __webpack_public_path__ + "static/media/maurizio-de-lisi.36625084.jpg";